const muscle = {
  getlist: 'muscle/getlist',
  add: 'muscle/add',
  update: 'muscle/update',
  remove: 'muscle/remove',
  get: 'muscle/get',
  getall: 'muscle/getall',
}
export default muscle
